import { render, staticRenderFns } from "./WasteBased.vue?vue&type=template&id=2c5fd386&"
import script from "./WasteBased.vue?vue&type=script&lang=js&"
export * from "./WasteBased.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports